export default "__VITE_ASSET__EBZdYYfj__"